import React, { useState } from 'react';

function ProductCard({ product, onAddToCart, onUpdateQuantity, cart = [], onImageClick }) {
  const cartItem = cart.find(item => item.id === product.id);
  const quantity = cartItem ? cartItem.quantity : 0;
  const [imageError, setImageError] = useState(false);

  const isMaxReached = quantity >= product.stock;
  
  const discount = product.originalPrice 
    ? Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)
    : 0;

  const handleAdd = () => {
    if (quantity >= product.stock) return;
    onAddToCart({ ...product, quantity: 1 });
  };

  const handleRemove = () => {
    if (quantity > 0) {
      onUpdateQuantity(product.id, quantity - 1);
    }
  };

  return (
    <div className="product-card">
      <div className="product-image-container">
        {discount > 0 && (
          <span className="discount-badge">{discount}% OFF</span>
        )}
        
        {quantity === 0 ? (
          <button
            className="add-btn-overlay"
            type="button"
            onClick={handleAdd}
            disabled={product.stock === 0}
            aria-label="Add to cart"
          >
            +
          </button>
        ) : (
          <div className={`qty-overlay ${isMaxReached ? 'max-reached' : ''}`}>
            <button
              className="qty-btn-small"
              type="button"
              onClick={handleRemove}
              aria-label="Decrease quantity"
            >
              −
            </button>
            <span className="qty-value-small">{quantity}</span>
            <button
              className="qty-btn-small"
              type="button"
              onClick={handleAdd}
              disabled={isMaxReached}
              aria-label="Increase quantity"
            >
              +
            </button>
          </div>
        )}

        {product.image && !imageError ? (
          <img 
            src={product.image} 
            alt={product.name} 
            className="product-image"
            onError={() => setImageError(true)}
            onClick={() => onImageClick && onImageClick(product)}
            loading="lazy"
            style={{ cursor: 'zoom-in' }}
          />
        ) : (
          <div className="product-image-placeholder">
            <span>📦</span>
          </div>
        )}
      </div>

      {product.unit && (
        <div className="unit-badge">{product.unit}</div>
      )}

      <div className="product-info">
        <h3 className="product-name">
          {product.brand ? `${product.brand} ${product.name}` : product.name}
        </h3>
      </div>

      <div className="product-price">
        <span className="price-current">₹{product.price}</span>
        {product.originalPrice && (
          <span className="price-original">₹{product.originalPrice}</span>
        )}
      </div>

      {product.stock > 0 && product.stock <= 5 && (
        <div className="stock-warning">Only {product.stock} left</div>
      )}

      {product.stock === 0 && (
        <div className="out-of-stock-overlay">
          <span>Out of Stock</span>
        </div>
      )}
    </div>
  );
}

export default ProductCard;
